// extracted by mini-css-extract-plugin
export var fileUpload = "_eg-1";
export var modalButton = "_eg-0";